import { render } from "./Upload.vue?vue&type=template&id=27c4d406&scoped=true"
import script from "./Upload.vue?vue&type=script&lang=js"
export * from "./Upload.vue?vue&type=script&lang=js"

import "./Upload.vue?vue&type=style&index=0&id=27c4d406&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-27c4d406"

export default script